module.exports = __webpack_public_path__ + "static/media/inf_wei_dis.203d3943.png";